module.exports = __webpack_public_path__ + "static/carregamento_casa-1c984750d78bd1d00d9d2239a45cb56d.jpg";